import * as React from 'react'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export type ImiDriverValidationInfo = {
  id: string
  name: string
  isLoading: boolean
  hasError: boolean
  missingFields: string[]
  apiError?: string
}

type ImiDriverValidationRowProps = {
  info: ImiDriverValidationInfo
  submitted: boolean
  dateRange: string
  countriesText: string
  operationTypesText: string
  transportTypesText: string
  vehiclesText: string
}


const ImiDriverValidationRow: React.FC<ImiDriverValidationRowProps> = ({
  info,
  submitted,
  dateRange,
  countriesText,
  operationTypesText,
  transportTypesText,
  vehiclesText,
}) => {
  const { t } = useLocalize()

  return (
    <tr
      className={`notches-border--right tw-border-b tw-border-base-300 ${
        (submitted && info.hasError) || info.apiError ? 'tw-bg-red-50' : 'tw-bg-white'
      }`}
    >
      <TableTextRow pointer={false}>{info.name}</TableTextRow>
      <TableTextRow pointer={false}>
        {info.isLoading ? (
          <span className="tw-text-content-base tw-text-opacity-60">
            {t('exportModule.validation-driver-loading')}
          </span>
        ) : info.hasError ? (
          <span className="tw-text-red-600" title={info.missingFields.join(', ')}>
            {t('imiExport.status-invalid')}
            <span className="tw-block tw-max-w-[260px] tw-text-xs">
              {info.missingFields.join(', ')}
            </span>
          </span>
        ) : info.apiError ? (
          <span className="tw-text-red-600">
            {t('imiExport.status-api-error')}
            <span className="tw-block tw-max-w-[260px] tw-break-words tw-text-xs">
              {info.apiError}
            </span>
          </span>
        ) : (
          <span className="tw-text-green-600">
            {t('imiExport.status-valid')}
          </span>
        )}
      </TableTextRow>
      <TableTextRow pointer={false}>{dateRange}</TableTextRow>
      <TableTextRow pointer={false}>
        <span
          className="tw-block tw-max-w-[200px] tw-truncate"
          title={countriesText || undefined}
        >
          {countriesText || '-'}
        </span>
      </TableTextRow>
      <TableTextRow pointer={false}>
        <span
          className="tw-block tw-max-w-[200px] tw-truncate"
          title={operationTypesText || undefined}
        >
          {operationTypesText || '-'}
        </span>
      </TableTextRow>
      <TableTextRow pointer={false}>
        <span
          className="tw-block tw-max-w-[200px] tw-truncate"
          title={transportTypesText || undefined}
        >
          {transportTypesText || '-'}
        </span>
      </TableTextRow>
      <TableTextRow pointer={false}>
        <span
          className="tw-block tw-max-w-[200px] tw-truncate"
          title={vehiclesText || undefined}
        >
          {vehiclesText || '-'}
        </span>
      </TableTextRow>
    </tr>
  )
}

export default ImiDriverValidationRow
